export enum ResetPasswordConstants {
  Title = 'Password reset required',
  Action = 'Click here to reset your password',
}
